
import type { IGetListParams } from '../types/index';

export const RoadmapRepository = Symbol('RoadmapRepository');

export interface RoadmapRepository {
    previewMeta(meta: any): Promise<any>;

    create(title: string, meta: any): Promise<any>;

    update(roadMapId: string, meta: any): Promise<any>;

    delete(roadMapId: string): Promise<any>;

    init(): Promise<any>;

    getList(params?: IGetListParams): Promise<any>;
}
